import { useSelectAppMode } from 'app/store/general/selectors';
import { AppMode } from 'app/store/general/AppMode';

export enum WellKnownLayoutOrigin {
    STANDALONE = 'standalone',
    WIDGETS = 'widgets',
    PALETTE = 'palette',
}

export function useAppLayoutOrigin() {
    const appMode = useSelectAppMode();
    switch (appMode) {
        case AppMode.EMBEDDED_SINGLE_WIDGET:
            return WellKnownLayoutOrigin.WIDGETS;
        case AppMode.EMBEDDED_DASHBOARD:
            return WellKnownLayoutOrigin.PALETTE;
        default:
            return WellKnownLayoutOrigin.STANDALONE;
    }
}
